import React from 'react'
import { Typography } from '@fullscreendigital/carrefour-dex-fe'
import { useTitle } from '../../useTitle'
import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { Button } from '@fullscreendigital/carrefour-dex-fe'
import s from "../../../../core-ui/Modal/Modal.modules.scss"

interface TitleHeaderProps {
  title: string
}

const TitleHeader: React.FC<TitleHeaderProps> = (props: TitleHeaderProps) => {
  const { title: headerTitle, modalVisible, modalMessage, handleModalOk } = useTitle();

  return (
    <div>
      <Typography
        component="h3"
        variant="regular"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
      >
        Carrefour
      </Typography>
      <Typography
        component="h2"
        variant="medium"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
      >
        {headerTitle}
      </Typography>
      <Typography
        component="h4"
        variant="medium"
        style={{ textAlign: 'center', textTransform: 'uppercase', color: 'black' }}
      >
        {props.title}
      </Typography>

      <Modal isModalOpen={modalVisible} closeModal={handleModalOk}>
        <Grid container spacing={4} style={{ marginBottom: '40px' }}>
          <Grid xs={12} item>
            {modalMessage}
          </Grid>
        </Grid>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="contained" label="OK" onClick={handleModalOk} />
        </Grid>
      </Modal>
    </div>
  )
}

export default TitleHeader
